module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-dots-2a4cb24d.svg";